import {yupResolver} from '@hookform/resolvers/yup'
import moment from 'moment'
import {enqueueSnackbar} from 'notistack'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm} from 'react-hook-form'
import * as Yup from 'yup'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {KTableLoading} from '../../../../../../components/UI'
import {InputDate} from '../../../../../../components/UI/Input'
import {Select} from '../../../../../../components/UI/Select'
import {formatDate} from '../../../../../../util/dates'
import {BedModel} from '../../../bed/model'
import {editBedService} from '../../../bed/services/editBed.service'
import {getBedByIdService} from '../../../bed/services/getBedById.service'
import {MasterModel} from '../../../modules/models'
import {getMasterModuleService} from '../../../modules/services'
import {RoomModel} from '../../models'
import {getRoomsService} from '../../services'
import {getSnackBarToast} from '../../../../../../util/snackBar'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  bedToEdit: BedModel
  getBeds: () => void
}

const ModalUpdateBed: FC<Props> = ({show, setShow, bedToEdit, getBeds}) => {
  const handleClose = () => {
    setShow(false)
  }

  const [, setRooms] = useState<RoomModel[] | any>([])
  const [bedTypes, setBedTypes] = useState<MasterModel[] | any>([])
  const [statusBed, setStatusBed] = useState<MasterModel[] | any>([])
  const [subStatusBed, setSubStatusBed] = useState<MasterModel[] | any>([])
  const [bedSize, setBedSizes] = useState<MasterModel[] | any>([])
  const [camaCaliente] = useState([
    {value: true, label: 'SI'},
    {value: false, label: 'NO'},
  ])
  const [showDateCC, setShowDateCC] = useState<boolean>(false)

  const [loading] = useState(false)

  const newBedSchema = Yup.object().shape({
    HabitacionId: Yup.string().required('Habitación es requerido'),
    Codigo: Yup.string().required('Nomenclatura de cama es requerido'),
    Descripcion: Yup.string().required('Notas de la cama es requerido'),
    TipoCamaId: Yup.string().required('Tipo de Cama es requerido'),
    EstadoCamaId: Yup.string().required('Estado de Cama es requerido'),
    SubEstadoCamaId: Yup.string().required('Sub Estado de Cama es requerido'),
    // MedidaCamaId: Yup.string().required('Tipo de Medida de Cama es requerido'),
    // Observaciones: Yup.string().required('Observaciones es requerido'),
  })

  const getSnackBar = (message: string, variant: boolean) => {
    enqueueSnackbar(message, {
      variant: variant ? 'success' : 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    })
  }

  const {
    register,
    setValue,
    handleSubmit,
    setError,
    control,
    formState: {errors},
  } = useForm<BedModel>({
    resolver: yupResolver(newBedSchema),
    defaultValues: {
      MedidaCamaId: null,
    },
  })

  const getRooms = async () => {
    try {
      const {data: response} = await getRoomsService({pageNumber: 1, size: 1000})
      const mappedRooms = response?.data?.map((item) => ({value: item.Id, label: item.Codigo}))
      setRooms(mappedRooms)
    } catch (error) {
      setRooms([])
    }
  }

  const getBedTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoCama',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setBedTypes(mappedMaster)
    } catch (error) {
      setBedTypes([])
    }
  }

  const getStatusBed = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoCama',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
        codigo: master.codigo,
      }))
      setStatusBed(mappedMaster)
    } catch (error) {
      setStatusBed([])
    }
  }

  const getSubStatusBed = async (statusPadre: string) => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'SubEstadoCama',
      })
      const data = response.data.data || []
      const filteredData = data?.filter((item) => item.codigoPadre === statusPadre)
      const mappedMaster = filteredData?.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setSubStatusBed(mappedMaster)
    } catch (error) {
      setSubStatusBed([])
    }
  }

  const getBedSizes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'MedidaCama',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setBedSizes(mappedMaster)
    } catch (error) {
      setBedSizes([])
    }
  }

  useEffect(() => {
    if (show) {
      getBedData()
    }
  }, [show])

  const getBedData = async () => {
    try {
      const {
        data: {data},
      } = await getBedByIdService(bedToEdit.Id)
      const {
        HabitacionId,
        Codigo,
        Descripcion,
        TipoCamaId,
        EstadoCamaId,
        SubEstadoCamaId,
        MedidaCamaId,
        CamaCaliente,
        // Observaciones,
        FechaIniCC,
        FechaFinCC,
      } = data
      setValue('Id', bedToEdit.Id)
      setValue('HabitacionId', HabitacionId)
      setValue('Descripcion', Descripcion)
      setValue('TipoCamaId', TipoCamaId)
      setValue('EstadoCamaId', EstadoCamaId)
      setValue('Codigo', Codigo)
      setValue('SubEstadoCamaId', SubEstadoCamaId)
      setValue('MedidaCamaId', MedidaCamaId)
      setValue('CamaCaliente', CamaCaliente)
      setValue('FechaIniCC', formatDate(FechaIniCC) as any)
      setValue('FechaFinCC', formatDate(FechaFinCC) as any)
      if (CamaCaliente) {
        setShowDateCC(true)
      } else {
        setShowDateCC(false)
      }
      const filtered = statusBed.filter((item: any) => item.value === EstadoCamaId)[0]?.codigo
      getSubStatusBed(filtered)
    } catch (error) {}
  }

  useEffect(() => {
    getRooms()
    getBedTypes()
    getStatusBed()
    // getSubStatusBed()
    getBedSizes()
    setValue('CamaCaliente', false)
    // setValue('HabitacionId', currentTabItem.idToEdit as any)
  }, [])

  const onSubmit = async (data: BedModel) => {
    try {
      const {data: res} = await editBedService(data)
      if (!res.error) {
        getSnackBarToast('Se actualizó con éxito', 'success')
        handleClose()
        getBeds()
        //mostrar snackbar
      } else {
        getSnackBarToast(res.message, 'error')
      }
    } catch (error) {}
  }

  const handleStatusChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('EstadoCamaId', value)
    const filtered = statusBed.filter((item: any) => item.value === value)[0]?.codigo
    getSubStatusBed(filtered)
    setError('EstadoCamaId', {})
    setValue('SubEstadoCamaId', '')
  }

  const handleGetFirstDate = (e: any) => {
    setValue('FechaIniCC', e.target.value)
    // let valueFirstDate = new Date(e.target.value)
    // let valueSecondDate = new Date(watch('FechaFinCC' as any))
    // if (valueSecondDate) {
    //   if (valueFirstDate.getTime() > valueSecondDate.getTime()) {
    //     setValue('FechaFinCC', '')
    //   } else {
    //     setValue('FechaFinCC', moment(valueSecondDate).format('YYYY-MM-DD'))
    //   }
    // }
  }
  const handleGetSecondDate = (e: any) => {
    setValue('FechaFinCC', e.target.value)
    // let valueSecondDate = new Date(e.target.value)
    // let valueFirstDate = new Date(watch('FechaIniCC' as any))
    // if (valueSecondDate) {
    //   if (valueFirstDate.getTime() > valueSecondDate.getTime()) {
    //     setValue('FechaIniCC', '')
    //   } else {
    //     setValue('FechaIniCC', moment(valueFirstDate).format('YYYY-MM-DD'))
    //   }
    // }
  }

  const handleCamaCalienteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CamaCaliente', value)
    setError('CamaCaliente', {})
    if (value) {
      setShowDateCC(true)
      // setValue('FechaIniCC', moment().format('YYYY-MM-DD'))
    } else {
      setShowDateCC(false)
      // setValue('FechaIniCC', '')
      // setValue('FechaFinCC', '')
    }
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Editar Cama</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            <div className='p-6'>
              <div className='d-flex'>
                <div className='col-6'>
                  <div className='mb-2 col-12'>
                    <label className='required form-label'>Nomenclatura de Cama</label>
                    <div
                      className='input-group input-group-sm'
                      style={{
                        width: '97%',
                      }}
                    >
                      <input type='text' className='form-control w-95' {...register('Codigo')} />
                    </div>
                    <p
                      style={{
                        marginBottom: '0',
                        fontSize: '10px',
                        fontWeight: '600',
                        color: 'red',
                        marginLeft: '5px',
                      }}
                    >
                      {errors.Codigo?.message}
                    </p>
                  </div>
                  <div className='mb-2 col-12'>
                    <label className='required form-label'>Notas de la Cama</label>
                    <div
                      className='input-group input-group-sm'
                      style={{
                        width: '97%',
                      }}
                    >
                      <input
                        type='text'
                        className='form-control w-95'
                        {...register('Descripcion')}
                      />
                    </div>
                    <p
                      style={{
                        marginBottom: '0',
                        fontSize: '10px',
                        fontWeight: '600',
                        color: 'red',
                        marginLeft: '5px',
                      }}
                    >
                      {errors.Descripcion?.message}
                    </p>
                  </div>
                  <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className='required'>Tipo de Cama:</label>
                    <Select control={control} name='TipoCamaId' data={bedTypes} errors={errors} />
                  </div>
                  <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className='required'>Estado de Cama:</label>
                    <Select
                      control={control}
                      name='EstadoCamaId'
                      data={statusBed}
                      errors={errors}
                      // valueChange={valueStatus}
                      onChangeValue={handleStatusChange}
                    />
                  </div>
                  <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className='required'>Sub Estado de Cama:</label>
                    <Select
                      control={control}
                      name='SubEstadoCamaId'
                      data={subStatusBed}
                      errors={errors}
                    />
                  </div>
                </div>
                <div className='col-6'>
                  <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className=''>Tipo de Medida de Cama:</label>
                    <Select control={control} name='MedidaCamaId' data={bedSize} errors={errors} />
                  </div>
                  <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className=''>Cama Caliente</label>
                    <Select
                      control={control}
                      name='CamaCaliente'
                      data={camaCaliente}
                      errors={errors}
                      onChangeValue={handleCamaCalienteChange}
                    />
                  </div>
                  {showDateCC ? (
                    <>
                      <div className='col-sm-12 col-lg-12'>
                        <label>Fecha Inicio :</label>
                        <InputDate
                          name='FechaIniCC'
                          register={register}
                          errors={errors}
                          defaultValue={moment().format('YYYY-MM-DD')}
                          minValue={moment().subtract(1, 'day').format('YYYY-MM-DD')}
                          onChange={(e: any) => handleGetFirstDate(e)}
                        />
                      </div>
                      <div className='col-sm-12 col-lg-12'>
                        <label>Fecha Fin:</label>
                        <InputDate
                          name='FechaFinCC'
                          register={register}
                          errors={errors}
                          minValue={moment().subtract(1, 'day').format('YYYY-MM-DD')}
                          onChange={handleGetSecondDate}
                        />
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>

            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button type='submit' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                Guardar
              </button>
            </div>
          </form>
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </div>
      </div>
    </Modal>
  )
}

export {ModalUpdateBed}
